<template>
  <el-form
      ref="form"
      :model="form"
      label-width="100px"
  >
    <gj-area-title v-if="isMeaningless(item) || item.status === shipmentBillEnum.WAIT_SHIPPED">产品明细</gj-area-title>
    <gj-table
        :columns="(isMeaningless(item) || item.status === shipmentBillEnum.WAIT_SHIPPED) ? columns : columns1"
        :data="form.items"
        :index="false"
        :show-overflow="false"
        :adapt-height-listen-update="false"
        :min-height="300"
        :offset-height="(isMeaningless(item) || item.status === shipmentBillEnum.WAIT_SHIPPED) ? 76 : 116"
        border
    >

      <template v-slot:header:expectSignDateHeader>
        <span class="colorRed">*</span>预计签收日期
        <el-popover placement="bottom" width="160" v-model="expectSignDateVisible">
          <div style="font-size: 12px;color:#333333;margin-top: -5px; padding-bottom:10px;margin-left: 5px;">
            <span>预计签收日期</span>
          </div>
          <gj-date-picker v-model="expectSignDate" type="date" placeholder="选择时间" style="margin-left: 6px;" width="150px"></gj-date-picker>
          <div style="text-align: right; margin-right:5px;margin-top: 15px">
            <gj-button size="mini" @click="expectSignDateVisible = false">取消</gj-button>
            <gj-button type="primary" size="mini" @click="batchExpectSignDate">确定</gj-button>
          </div>
          <gj-button type="text" slot="reference">批量</gj-button>
        </el-popover>
      </template>

      <template v-slot:productInfo="{row}">
        <div>{{row.productName}}</div>
        <div>{{row.sku}}</div>
        <div>{{row.categoryName	}}</div>
      </template>

      <template v-slot:msku="{row}">
        <div>{{row.msku}}</div>
        <div>{{row.fnsku}}</div>
        <div>{{row.asin}}</div>
      </template>

      <template v-slot:shipmentId="{row}">
        <div>{{row.shipmentId}}</div>
        <div>{{row.quantityShipped}}</div>
      </template>

      <template v-slot:tfCode="{row}">
        <template v-for="(shipItem, index) in row.shipTransferItemVOList">
          <div :key="index"
               :style="{'border-bottom': index + 1 !== row.shipTransferItemVOList.length ? '1px solid #EBEEF5' : 'unset'}" style="margin: 0 -10px; padding: 0 4px; text-align: center;height:36px;">
            <div>{{shipItem.transferCode}}</div>
            <div>{{shipItem.quantity}}({{shipItem.ableQuantity}})</div>
          </div>
        </template>
      </template>

      <template v-slot:deduction="{row}">
        <template v-for="(shipItem, index) in row.shipTransferItemVOList">
          <div :key="index"
               :style="{'border-bottom': index + 1 !== row.shipTransferItemVOList.length ? '1px solid #EBEEF5' : 'unset'}" style="margin: 0 -10px; padding: 0 4px;height:36px; display: flex; align-items: center; justify-content: center;">
            <div>{{row.shipQuantity === '' ? 0 : shipItem.shipQuantity}}</div>
          </div>
        </template>
      </template>

      <template v-slot:header:quantity>
        <span class="colorRed">*</span>发货量
      </template>

      <template v-slot:quantity="{index, row}">
        <el-form-item
            class="gj-table-item not-form-item-mgb"
            label-width="0"
            :prop="`items.${index}.shipQuantity`"
            :rules="[
              {required: true, message: '请输入发货量', trigger: ['blur', 'change']},
              $gjReRule(RE.pt0, '请输入0或正整数')
            ]">
          <gj-input
              v-model="row.shipQuantity"
              @input="handleInputControl($event, row)"
          ></gj-input>
        </el-form-item>
      </template>

      <template v-slot:date="{index, row}">
        <el-form-item
            :prop="`items.${index}.expectSignDate`"
            :rules="[
              {required: dateRequired(form.items[index].shipQuantity), message: '请选择日期', trigger: ['blur', 'change']},
            ]"
            class="gj-table-item not-form-item-mgb"
            label-width="0">
          <gj-date-picker
              placeholder="请选择日期"
              v-model="row.expectSignDate"></gj-date-picker>
        </el-form-item>
      </template>

      <template v-slot:gap="{row}">
        {{Number(row.receiptQuantity || 0) - Number(row.shipQuantity || 0)}}
      </template>

      <template #footer>
        <div class="default">
          <div style="margin-right: 20px;">
            <span>商品种类数：</span>
            <span>{{form.items.length}}</span>
          </div>
          <div>
            <span>发货量合计：</span>
            <span>{{getShipmentTotal()}}</span>
          </div>
        </div>
      </template>
    </gj-table>
  </el-form>
</template>

<script>
  import {formRuleMixin, isMeaninglessMixin} from "../../../../../minxins";
  import {shipmentBillEnum} from "../../../logistics/shipment-bill/enum";
  import {mapGetters} from "vuex";
  import {isMeaningful, isMeaningless} from "@/utils/common";
  export default {
    name: "app-shipment-bill-product-detail",
    mixins: [formRuleMixin, isMeaninglessMixin],
    props: {
      item: null,
      productItems: null,
    },
    computed: {
      ...mapGetters({
        marketOption: 'marketOption'
      }),
    },
    watch: {
      productItems: {
        immediate: true,
        handler(value) {
          this.form.items = value || [];
        }
      }
    },
    data() {
      return {
        columns: [
          {id: 'warehouseName', header: '目的仓', field: 'warehouseName', minWidth: '110px'},
          {id: 'centerId', header: '亚马逊仓代码', field: 'centerId', minWidth: '100px'},
          {id: 'arrivalMarketId', header: '店铺/国家', field: 'option:arrivalMarketId', minWidth: '120px', options: () => this.marketOption},
          {id: 'productInfo', header: '产品名称/SKU/产品类型-品类', field: 'slot:productInfo', minWidth: '120px'},
          {id: 'msku', header: 'MSKU/FNSKU/ASIN', field: 'slot:msku', minWidth: '130px'},
          {id: 'shipmentId', header: '货件号/申报量', field: 'slot:shipmentId', minWidth: '120px'},
          {id: 'tfCode', header: '调拨单号/单据量', field: 'slot:tfCode', minWidth: '160px'},
          {id: 'deduction', header: '单据量扣除量', field: 'slot:deduction', minWidth: '60px'},
          {id: 'quantity', header: 'slot:quantity', field: 'slot:quantity', minWidth: '120px'},
          {id: 'date', header: 'slot:expectSignDateHeader', field: 'slot:date', minWidth: '140px'},
        ],
        columns1: [
          {id: 'warehouseName', header: '目的仓', field: 'warehouseName', minWidth: '110px'},
          {id: 'centerId', header: '亚马逊仓代码', field: 'centerId', minWidth: '100px'},
          {id: 'arrivalMarketId', header: '店铺/国家', field: 'option:arrivalMarketId', minWidth: '120px', options: () => this.marketOption},
          {id: 'productInfo', header: '产品名称/SKU/产品类型-品类', field: 'slot:productInfo', minWidth: '120px'},
          {id: 'msku', header: 'MSKU/FNSKU/ASIN', field: 'slot:msku', minWidth: '160px'},
          {id: 'shipmentId', header: '货件号/申报量', field: 'slot:shipmentId', minWidth: '120px'},
          {id: 'tfCode', header: '调拨单号/单据量', field: 'slot:tfCode', minWidth: '160px'},
          {id: 'deduction', header: '单据量扣除量', field: 'slot:deduction', minWidth: '60px'},
          {id: 'shipQuantity', header: '发货量', field: 'shipQuantity', minWidth: '60px', align: 'right'},
          {id: 'expectSignDate', header: '预计签收日期', field: 'expectSignDate', minWidth: '130px'},
          {id: 'receiptQuantity', header: '收货量', field: 'receiptQuantity', minWidth: '60px', align: 'right'},
          {id: 'gap', header: '收发差距', field: 'slot:gap', minWidth: '80px', align: 'right'},
        ],
        form: {
          items: [],
        },
        shipmentBillEnum: shipmentBillEnum,
        expectSignDate: null,
        expectSignDateVisible: false
      }
    },
    methods: {
      batchExpectSignDate() {
        this.form.items.forEach(item => {
          item.expectSignDate = this.expectSignDate;
        })
        this.expectSignDateVisible = false;
      },
      getShipmentTotal() {
        let sum = 0;
        this.form.items.forEach(v => sum += Number(v.shipQuantity));
        return sum;
      },
      dateRequired(value) {
        return !(isMeaningful(value) && this.RE.pt0.test(value) && Number(value) === 0);
      },
      /**
       * 发货量控制
       * @param e
       * @param row
       */
      handleInputControl (e, row) {
        if (isMeaningless(e)) {
          return;
        }
        const nums = row.shipTransferItemVOList && row.shipTransferItemVOList.length
                ? row.shipTransferItemVOList
                        .map(v => v.shipQuantity)
                        .reduce((p, n) => parseInt(p) + parseInt(n), 0)
                : 0
        row.shipQuantity = parseInt(e) <= nums && parseInt(e) <= row.maxReceiptQuantity && parseInt(e) > 0 ? e : row.maxReceiptQuantity;

        let restQuantity = row.shipQuantity;
        row.shipTransferItemVOList.forEach(item => {
          if (restQuantity > 0) {
            if (restQuantity > item.ableQuantity) {
              item.shipQuantity = item.ableQuantity;
              restQuantity -= item.ableQuantity;
            } else {
              item.shipQuantity = restQuantity;
              restQuantity = 0;
            }
          } else {
            item.shipQuantity = 0;
          }
        });
      }
    }
  }
</script>

<style lang="scss" scoped>
  /deep/ .gj-table{
    padding-bottom: 1px;
  }
  /deep/ .el-tabs__item{
    padding: 0 16px;
  }
</style>
